import { combineReducers } from '@reduxjs/toolkit';
import { reducer as allConsultationsReducer } from './model/consultations';
import { reducer as violationsReducer } from './model/violators';
export * as ConsultationsModel from './model';

const consultationsReducer = combineReducers({
  consultations: allConsultationsReducer,
  violators: violationsReducer,
});

export default consultationsReducer;
